export default __webpack_public_path__ + "static/media/arrow.7c4a777e.png";